
import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-store-3-line',
    title: 'Skip the Dealership',
    description:
      'No more haggling with pushy salespeople. We handle the entire buying or selling process so you never have to step foot on a dealer lot.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'We Find Your Perfect Match',
    description:
      'Tell us what you want and we source it from our nationwide network at the best possible price.',
    linkText: 'Browse our inventory',
    linkTo: '/inventory',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Sell Your Car Direct',
    description:
      'Get top dollar for your vehicle by selling it directly through us. No lowball trade-in offers, no middlemen taking a cut.',
    linkText: 'Or try consignment',
    linkTo: '/consignment',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Transparent Pricing',
    description:
      'No hidden fees, no surprise add-ons. You see exactly what you pay and exactly what you get — on both sides of the deal.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Financing Made Simple',
    description:
      'Access competitive rates from multiple lenders with personalized financing solutions tailored to your situation.',
    linkText: 'Explore financing',
    linkTo: '/financing',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Support After the Sale',
    description:
      "Our relationship doesn't end when you drive away. We're here for questions, maintenance coordination, and future purchases.",
    linkText: 'Read customer reviews',
    linkTo: '/reviews',
  },
];

export default function BuyAndSellFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold text-[#1C2B1E] mb-4">
            Why Choose Our Buy & Sell Services?
          </h2>
          <div className="w-24 h-1 bg-[#E8B84B] mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            We've reimagined the car buying and selling experience to put you in control. 
            Think of us as your personal car concierge.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#F7F5F0] rounded-2xl p-8 border-2 border-[#E8E2D6] hover:border-[#E8B84B] transition-all group"
            >
              <div className="w-16 h-16 bg-[#E8B84B] rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-[#1C2B1E]`}></i>
              </div>
              <h3 className="font-['Oswald'] text-2xl font-bold text-[#1C2B1E] mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">{feature.description}</p>
              {feature.linkText && feature.linkTo && (
                <Link
                  to={feature.linkTo}
                  className="inline-flex items-center gap-1 text-[#E8B84B] hover:text-[#d4a03d] font-medium transition-colors cursor-pointer"
                >
                  {feature.linkText}
                  <i className="ri-arrow-right-s-line"></i>
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
